import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { getFeedbackDetails } from "../../Services/Feedback";
import { format_date } from "../../Utils/helpers";
import { image_url } from "../../Utils/connection_strings";
import BackButton from "../../Components/BackButton";
import ModalImageViewer from "../../Components/ModalImageViewer";
import "../Dashboard/Dashboard.css";

export default function FeedbackDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [feedback, setFeedback] = useState({});
  const [showViewer, setShowViewer] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);

  const { data, isLoading, refetch } = useQuery(["feedback_details", id], () =>
    getFeedbackDetails(id)
  );

  useEffect(() => {
    if (data?.data?.data?.docs?.length > 0)
      setFeedback(data?.data?.data?.docs?.[0]);
  }, [data?.data?.data?.docs]);

  const imagesList = feedback?.images?.map(img => `${image_url}${img}`) || [];

  const handleImageClick = (index) => {
    setViewerIndex(index);
    setShowViewer(true);
  };

  return (
    <div className="app-content content dashboard">
      <div className="content-wrapper">
        <div className="content-body">
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="back-title d-flex align-items-center">
                        <BackButton />
                        <h1 className="pageTitle m-0 ms-3 fw-800">Feedback Details</h1>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-12">
                      <div className="details-card-premium p-4 p-lg-5 bg-white rounded-4 shadow-sm border">
                        <div className="row">
                          <div className="col-xxl-8">
                            {[
                              { label: "Full Name:", value: feedback?.user?.firstName || feedback?.fullName || "-" },
                              { label: "Email Address:", value: feedback?.email || "-" },
                              { label: "User Type:", value: feedback?.user?.role || "-" },
                              { label: "Subject:", value: feedback?.subject || "-" },
                              { label: "Date Submitted:", value: feedback?.createdAt ? format_date(feedback?.createdAt, "DD/MM/YYYY") : "-" },
                              { label: "Description:", value: feedback?.description || "-" },
                            ].map((item, index) => (
                              <div key={index} className={`mainDetail d-xl-flex align-items-baseline ${index === 5 ? 'border-0' : ''}`}>
                                <label className="mainLabel fw-semibold text-secondary" style={{ minWidth: "200px" }}>{item.label}</label>
                                <p className="mainText fw-bold text-dark">{item.value}</p>
                              </div>
                            ))}

                            {/* Images Section */}
                            {imagesList.length > 0 && (
                              <div className="mainDetail d-block border-0 mt-4">
                                <label className="mainLabel fw-semibold text-secondary mb-3 d-block">Images:</label>
                                <div className="d-flex flex-wrap gap-3">
                                  {imagesList.map((img, index) => (
                                    <div
                                      key={index}
                                      onClick={() => handleImageClick(index)}
                                      style={{ cursor: "pointer" }}
                                      className="image-hover-wrapper"
                                    >
                                      <img
                                        src={img}
                                        alt={`feedback-${index}`}
                                        className="rounded-3 shadow-sm border"
                                        style={{
                                          width: "120px",
                                          height: "120px",
                                          objectFit: "cover",
                                          transition: "transform 0.2s"
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <ModalImageViewer
        show={showViewer}
        images={imagesList}
        startIndex={viewerIndex}
        onHide={() => setShowViewer(false)}
        title="Feedback Images"
      />
    </div>
  );
}
